import { BaseEntity } from '../base-entity';
import { PbiDatasetRefresh } from './pbi-dataset-refresh';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export interface DataRefresh {
  id: string;
  acceptedAt: Date;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  orchestratorInstanceId?: string;
  settledAt?: Date;
  startedAt?: Date;
  status: string;
  tenantKey: string;
  triggerSource: string;
  datasetRefreshes: PbiDatasetRefresh[];
}

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class DataRefresh extends BaseEntity {
  /// <code> Place custom code between <code> tags
  /// </code>
  // Generated code. Do not place code below this line.
}
